import { useTranslation } from 'react-i18next';
import type aiMedia from '../../public/locales/en/aiMedia.json';
import type documentTranslation from '../../public/locales/en/documentTranslation.json';
import type profileChanges from '../../public/locales/en/profileChanges.json';

interface Messages {
  aiMedia: typeof aiMedia;
  documentTranslation: typeof documentTranslation;
  profileChanges: typeof profileChanges;
}
type MessageKey<T> = { [K in keyof T & string]: T[K] extends string ? K : `${K}.${MessageKey<T[K]>}` }[keyof T & string];

// Keep these small namespaces typed without expanding the legacy translation tree
// in CRA's incremental checker (TS2589). Type-only imports emit no public-directory import.
export const useDmpTranslation = useTranslation as unknown as <N extends keyof Messages>(namespace: N) => {
  t: (key: MessageKey<Messages[N]>, options?: Record<string, unknown>) => string;
};
